<!--
 * @Description: 文件内容描述
 * @Author: 编辑人
 * @Date: 2021-08-02 09:28:52
-->
<template>
  <section
    class="app-main"
    :style="
      $route.path != '/index'
        ? 'height: calc(100vh - 84px);'
        : 'height: calc(100vh - 84px);'
    "
  >
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    cachedViews() {
      // const keepmenu = this.$store.state.tagsView.cachedViews;
      // const arr = [];
      // if (keepmenu && keepmenu.length !== 0) {
      //   keepmenu.forEach(item => {
      //     arr.push(item.name);
      //     console.log(item.name)
      //   });
      // }
      // return arr;
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    }
  }
};
</script>

<style lang="scss" scoped>
.app-main {
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #f3f7fd;
  border-top: 10px solid #f1f5ff;
  border-left: 10px solid #f1f5ff;
  border-right: 10px solid #f1f5ff;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    min-height: calc(100vh - 84px);
  }
  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
